{
  "nav": {
    "aria": "เมนูหลัก",
    "howItWorks": "AI ทำงานอย่างไร",
    "pricing": "ราคา",
    "faq": "คำถามที่พบบ่อย",
    "toApp": "ไปที่หน้าหลักของร้าน",
    "toAppShort": "ไปที่หน้าหลัก",
    "login": "เข้าสู่ระบบ",
    "startFree": "เริ่มใช้ฟรี"
  },
  "hero": {
    "headline": "ให้ AI ตอบลูกค้า ด้วยราคาและสต็อกจริง ของร้านคุณ",
    "sub": "เชื่อม LINE OA, Facebook และ Instagram แล้ว AI จะตอบคำถาม ส่งรูปสินค้า สรุปออเดอร์ และส่ง QR พร้อมเพย์ให้ลูกค้าได้ทั้งวันทั้งคืน เรื่องไหนต้องใช้คน ระบบส่งต่อให้ทีมของคุณทันที",
    "cta": "เริ่มใช้ฟรี 7 วัน",
    "terms": "ไม่ต้องใช้บัตรเครดิต · หลังทดลอง 699 บาท/เดือน",
    "worksWith": "ใช้กับ"
  },
  "scene": {
    "aria": "ตัวอย่างแชท: ลูกค้าถามหาเสื้อเชิ้ตลินินตอน {{time}} AI ตอบราคาและสต็อก ส่งรูปสินค้า แล้วสรุปออเดอร์ยอด {{total}} บาทพร้อม QR พร้อมเพย์",
    "shopName": "บ้านลินิน",
    "status": "ร้านปิดแล้ว · AI กำลังตอบ",
    "aiLabel": "AI",
    "customer1": "เสื้อเชิ้ตลินินสีครีม ไซซ์ M ยังมีไหมคะ",
    "ai1": "มีค่ะ ไซซ์ M เหลือ 3 ตัว ราคา 590 บาท ส่งรูปให้ดูนะคะ",
    "productName": "เสื้อเชิ้ตลินิน · ครีม",
    "productStock": "ไซซ์ M · เหลือ 3",
    "customer2": "เอา 1 ตัวค่ะ ส่งที่อยู่เดิมเลย",
    "ai2": "สรุปออเดอร์ให้แล้วค่ะ สแกน QR พร้อมเพย์เพื่อชำระได้เลยค่ะ",
    "orderTitle": "สรุปออเดอร์",
    "orderItem": "เสื้อเชิ้ตลินิน ครีม M × 1",
    "orderShipping": "ค่าส่ง",
    "orderTotal": "ยอดรวม",
    "orderPay": "ชำระผ่านพร้อมเพย์"
  },
  "walkthrough": {
    "title": "ดู AI ปิดการขายหนึ่งรายการ ตั้งแต่ต้นจนจบ",
    "sub": "ทุกขั้นใช้ข้อมูลของร้านคุณเอง ทั้งแคตตาล็อก ค่าส่ง และบัญชีรับเงิน",
    "steps": {
      "catalogue": {
        "title": "ค้นสินค้าในแคตตาล็อก",
        "body": "อ่านราคาและสต็อกของแต่ละไซซ์และสีจากสินค้าในร้าน ราคาที่ตอบมาจากแคตตาล็อก ส่วนยอดรวมระบบคำนวณให้"
      },
      "photos": {
        "title": "ส่งรูปสินค้า",
        "body": "เลือกรูปจากสินค้าที่คุณลงไว้ ส่งให้ลูกค้าดูในแชท"
      },
      "customer": {
        "title": "จำข้อมูลลูกค้า",
        "body": "บันทึกชื่อ เบอร์โทร และที่อยู่ลง CRM ครั้งหน้าลูกค้าพิมพ์แค่ \"ส่งที่อยู่เดิม\""
      },
      "order": {
        "title": "สรุปออเดอร์",
        "body": "ระบบคำนวณยอดและค่าส่งให้ ลูกค้ากดยืนยันเอง หรือรอแอดมินอนุมัติก่อนก็ได้"
      },
      "payment": {
        "title": "ส่ง QR พร้อมเพย์",
        "body": "ส่ง QR และเลขบัญชีของร้านให้ลูกค้าโอนได้ทันที"
      },
      "handoff": {
        "title": "ส่งต่อให้ทีม",
        "body": "ลูกค้าขอคุยกับคน หรือถามเกินข้อมูลที่มี AI จะแจ้งลูกค้าและส่งแชทให้ทีมของคุณ"
      }
    },
    "soldOut": "หมด",
    "left": "เหลือ {{count}}",
    "colours": ["ครีม", "เขียวเสจ", "เทาถ่าน"],
    "customerName": "คุณมะลิ วงศ์ใหญ่",
    "customerPhone": "081-xxx-4521",
    "customerAddress": "12/3 ถ.นิมมานเหมินท์ ต.สุเทพ อ.เมือง เชียงใหม่ 50200",
    "savedToCrm": "บันทึกใน CRM แล้ว",
    "promptPay": "พร้อมเพย์",
    "account": "บ้านลินิน · กสิกรไทย",
    "handoffMessage": "ขอคุยกับแอดมินหน่อยค่ะ จะเปลี่ยนที่อยู่จัดส่ง",
    "handoffTag": "ต้องการความช่วยเหลือ"
  },
  "controls": {
    "title": "คุณกำหนดเองว่า AI ทำอะไรได้บ้าง",
    "sub": "ตั้งค่าครั้งเดียวในหน้าผู้ช่วย AI ปรับได้ทุกเมื่อ",
    "points": [
      {
        "title": "น้ำเสียงและภาษา",
        "body": "เลือกตอบแบบเป็นกันเอง ทางการ หรือสนุกสนาน ตอบไทยหรืออังกฤษตามภาษาที่ลูกค้าพิมพ์ และกำหนดการใช้คำเองได้ เช่น เรียกลูกค้าว่า คุณลูกค้า"
      },
      {
        "title": "สิทธิ์สร้างออเดอร์",
        "body": "ให้ลูกค้ายืนยันออเดอร์เอง หรือให้แอดมินอนุมัติทุกออเดอร์ก่อนส่ง QR"
      },
      {
        "title": "ข้อมูลที่ AI ใช้ตอบ",
        "body": "คำถามที่พบบ่อย นโยบายจัดส่งและคืนสินค้า และค่าส่งกับเงื่อนไขส่งฟรีที่ตั้งไว้ในหน้าการจัดส่ง"
      },
      {
        "title": "ปิดได้ทุกเมื่อ",
        "body": "เลือกช่องทางที่ให้ AI ตอบ และปิด AI ในแชทไหนก็ได้ พอทีมตอบในแชทไหน AI ก็หยุดตอบแชทนั้นให้เอง"
      }
    ],
    "notesValue": "เรียกลูกค้าว่า คุณลูกค้า"
  },
  "clock": {
    "title": "คุณตอบแชทได้วันละ 9 ชั่วโมง ส่วน AI ตอบได้ครบ 24",
    "sub": "ข้อความที่เข้ามาตอนดึกได้คำตอบภายในไม่กี่วินาที เช้ามาคุณเห็นออเดอร์ที่รอแพ็ก แทนที่จะเป็นแชทค้าง",
    "aria": "แผนภาพ 24 ชั่วโมง: คุณตอบแชทได้ช่วง 09:00 ถึง 18:00 ส่วน AI ตอบได้ตลอด 24 ชั่วโมง",
    "you": "คุณ",
    "youHours": "09:00–18:00",
    "ai": "AI",
    "aiHours": "ตลอด 24 ชั่วโมง",
    "markers": [
      {
        "time": "23:40",
        "text": "ส่งเชียงใหม่กี่วันคะ"
      },
      {
        "time": "02:14",
        "text": "ไซซ์ M ยังมีไหมคะ"
      },
      {
        "time": "06:05",
        "text": "โอนแล้วนะคะ"
      }
    ]
  },
  "team": {
    "title": "เมื่อร้านโตขึ้น ทั้งทีมทำงานในกล่องข้อความเดียว",
    "sub": "AI รับแชทจำนวนมากไว้ก่อน ทีมของคุณดูแลเฉพาะเรื่องที่ต้องใช้คน",
    "points": [
      "แชท LINE OA, Facebook และ Instagram รวมในกล่องเดียว",
      "แท็บ \"ต้องการความช่วยเหลือ\" รวมแชทที่ AI ส่งต่อมาให้",
      "แอดมิน 3 ที่นั่ง กำหนดสิทธิ์แต่ละคนได้ ซื้อที่นั่งเพิ่มได้",
      "โปรไฟล์ลูกค้า ประวัติแชท และออเดอร์ อยู่ข้างบทสนทนา",
      "ติดตามการชำระเงินและการจัดส่งของทุกออเดอร์"
    ]
  },
  "pricing": {
    "title": "ราคาเดียว ได้ครบทุกอย่าง",
    "sub": "ทดลองฟรี 7 วันก่อน แล้วค่อยตัดสินใจ ต่ออายุเมื่อคุณต้องการเท่านั้น",
    "term": "แพ็กเกจรายเดือน",
    "perMonth": "/ เดือน",
    "vat": "รวม VAT · ชำระครั้งเดียวต่อรอบ",
    "cta": "เลือกแพ็กเกจนี้",
    "trial": "ทดลองฟรี {{days}} วันก่อน",
    "noCard": "ไม่ต้องใช้บัตรเครดิต",
    "features": [
      "ผู้ช่วย AI ตอบแชทอัตโนมัติ (มีโควตาการใช้งานรายวัน)",
      "เชื่อมต่อ LINE OA, Facebook และ Instagram",
      "แอดมิน 3 ที่นั่ง ซื้อเพิ่มได้ภายหลัง",
      "สินค้า ออเดอร์ และการจัดส่งในระบบเดียว",
      "CRM ลูกค้าไม่จำกัด พร้อมประวัติแชทย้อนหลัง",
      "ซัพพอร์ตภาษาไทยผ่าน LINE OA"
    ],
    "benefits": ["ชำระค่าแพ็กเกจผ่านพร้อมเพย์", "ไม่มีสัญญาผูกมัด ไม่คิดเงินต่อข้อความ"]
  },
  "faq": {
    "title": "คำถามที่พบบ่อย",
    "items": [
      {
        "question": "AI จะตอบผิดหรือแต่งราคาเองไหม?",
        "answer": "AI ดึงราคาและสต็อกจากสินค้าในร้านของคุณ ส่วนยอดออเดอร์และค่าส่งคำนวณโดยระบบ ไม่ใช่ AI ถ้าคำถามเกินข้อมูลที่มี AI จะแจ้งลูกค้าและส่งแชทให้ทีมของคุณ"
      },
      {
        "question": "ปิด AI หรือให้ทีมตอบเองบางแชทได้ไหม?",
        "answer": "ได้ เลือกได้ว่าจะให้ AI ตอบช่องทางไหน ปิดทั้งหมดได้ในหน้าผู้ช่วย AI และหยุด AI ทีละแชทได้จากหน้าแชท"
      },
      {
        "question": "ใช้ AI ได้ไม่จำกัดหรือเปล่า?",
        "answer": "แพ็กเกจมีโควตาการใช้งาน AI ต่อวัน ดูยอดที่ใช้ไปแล้วได้ในแท็บการใช้งานของหน้าผู้ช่วย AI"
      },
      {
        "question": "ใช้กับ LINE OA แบบ Premium ได้ไหม?",
        "answer": "ได้ ใช้ได้ทั้งบัญชี Free และ Premium ผ่าน Messaging API"
      },
      {
        "question": "ข้อมูลลูกค้าและแชทเก็บที่ไหน?",
        "answer": "แชทและข้อมูลลูกค้าเก็บบน Google Cloud ส่วนรูปและไฟล์ในแชทเก็บบน Cloudflare เข้ารหัสทั้งระหว่างส่งและขณะจัดเก็บ ขอลบข้อมูลทั้งหมดได้ตามนโยบายความเป็นส่วนตัว"
      },
      {
        "question": "คิดเงินตามจำนวนข้อความหรือเปล่า?",
        "answer": "ไม่ คิดเหมาจ่ายรายเดือน ไม่มีค่าใช้จ่ายต่อข้อความหรือต่อลูกค้า"
      },
      {
        "question": "เพิ่มที่นั่งแอดมินระหว่างรอบบิลได้ไหม?",
        "answer": "ได้ ระบบคิดราคาตามจำนวนวันที่เหลือของรอบบิลปัจจุบัน"
      },
      {
        "question": "มีสัญญาผูกมัดไหม? ยกเลิกได้เมื่อไร?",
        "answer": "ไม่มีสัญญาผูกมัด ยกเลิกการต่ออายุได้ทุกเมื่อในหน้าแพ็กเกจ ใช้งานต่อได้จนสิ้นรอบบิลปัจจุบัน ค่าบริการที่ชำระแล้วไม่สามารถขอคืน"
      },
      {
        "question": "มีทีมซัพพอร์ตภาษาไทยไหม?",
        "answer": "มี ติดต่อผ่าน LINE OA @sightorder ตอบในเวลาทำการ"
      }
    ]
  },
  "finalCta": {
    "title": "ให้ AI เริ่มตอบลูกค้าของคุณคืนนี้",
    "sub": "ทดลองฟรี 7 วัน ไม่ต้องใช้บัตรเครดิต",
    "button": "เริ่มใช้ฟรี 7 วัน"
  },
  "footer": {
    "tagline": "AI ตอบแชทและปิดการขาย สำหรับร้านค้าออนไลน์ไทย",
    "productHeading": "ผลิตภัณฑ์",
    "supportHeading": "ช่วยเหลือ",
    "legalHeading": "กฎหมาย",
    "howItWorks": "AI ทำงานอย่างไร",
    "pricing": "ราคา",
    "terms": "เงื่อนไขการใช้งาน",
    "privacy": "นโยบายความเป็นส่วนตัว"
  },
  "mockup": {
    "conversations": ["คุณนัท", "K. Bell", "คุณตาล", "บีม"],
    "messages": ["สวัสดีค่ะ", "ขอเพิ่มคุกกี้ 2 กล่องนะคะ", "ได้เลยค่ะ ❤️", "โอนแล้วค่ะ 🙏"],
    "composerPlaceholder": "พิมพ์ข้อความ…",
    "customerName": "คุณนัท",
    "customerTag": "VIP · ลูกค้าประจำ",
    "statSpend": "ยอดซื้อ",
    "statConversations": "บทสนทนา",
    "statSince": "เริ่ม",
    "statSinceValue": "มี.ค. 2025"
  }
}
